import { connect } from 'react-redux';

// actions
import { getPhotos, editPhoto, addMultiplePhotos } from 'actions/website/entities/PhotosActions';
import { resetEntities, addEntity } from 'actions/website/EntityActions';
import { saveCrop, tempUploadPromise } from 'actions/website/FileUploadActions';
import { showModal, hideModal } from 'actions/ModalActions';
import { togglePage } from 'actions/website/PageActions';

// types
import type { CreatePhotosRequest, WCmsPageView } from '@zola/svc-web-api-ts-client';
import type { FilePreviewType } from 'actions/types/website/FileUploadActionTypes';
import type { GenericEntityType } from 'actions/types/website/EntityActionTypes';
import type { RootState, AppDispatch } from 'reducers/index';

import Photos from './Photos';

export type PhotosMapStateProps = {
  entities: Record<number, GenericEntityType>;
  orderedIds: number[];
  page: WCmsPageView;
  photoFilePreview: FilePreviewType;
  themeKey?: string;
};

const mapStateToProps = (state: RootState) => ({
  entities: state.website.entities.byId,
  orderedIds: state.website.entities.orderedIds,
  page: state.website.pages.byId[state.website.pages.typeToId.PHOTO],
  photoFilePreview: state.website.entities.filePreview?.new_photo || {},
  themeKey: state.wedding.theme.key,
});

export type PhotosMapDispatchProps = {
  closeModal: () => void;
  getPhotoEntities: () => void;
  onEdit: (photo: GenericEntityType) => void;
  onPageToggle: (pageId: number) => void;
  onPhotoSelect: (file: FilePreviewType) => void;
  openCropModal: (image: FilePreviewType) => void;
  openSaveModal: (image: FilePreviewType) => void;
  submitMultiPhotos: (
    payload: CreatePhotosRequest,
    photoLimit: number
  ) => Promise<GenericEntityType[]>;
  unloadEntities: () => void;
};

const mapDispatchToProps = (dispatch: AppDispatch): PhotosMapDispatchProps => ({
  openCropModal: image => {
    dispatch(
      showModal('CROP_MODAL', {
        aspectRatio: 1,
        imageUrl: image.url,
        onCropSelect: (crop: { height: number; width: number; x: number; y: number }) => {
          dispatch(saveCrop(image.s3_bucket, image.s3_key, crop, image.content_type, 'new_photo'));
        },
        subcopy: "Don't want a white border? Drag the corners and crop your photo to a square.",
      })
    );
  },
  openSaveModal: image => {
    dispatch(addEntity());
    dispatch(showModal('PHOTO', { newPhoto: image }, { size: 'md' }));
  },
  getPhotoEntities: () => {
    dispatch(getPhotos());
  },
  onEdit: photo => {
    dispatch(editPhoto(photo));
    dispatch(showModal('PHOTO', { isUpdate: true, photo }, { size: 'md' }));
  },
  submitMultiPhotos: (payload, photoLimit) => {
    return dispatch(addMultiplePhotos(payload, photoLimit));
  },
  unloadEntities: () => {
    dispatch(resetEntities());
  },
  onPhotoSelect: file => dispatch(tempUploadPromise(file, 'new_photo')),
  onPageToggle: pageId => dispatch(togglePage(pageId)),
  closeModal: () => dispatch(hideModal()),
});

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(Photos);
